module.exports = __webpack_public_path__ + "img/lamdeini2.ad2d84dd.jpg";